import { INTEGRATION_TYPE } from "@/Pages/Integrations/types";
import { ROUTES } from "@/shared";
import { useIntegrationsDialogStore } from "@/stores/useIntegrationsDialogStore";

import PageHeaderActions from "../PageHeaderActions";

const IntegrationsApiHeaderActions = () => {
  const { openAddDialog } = useIntegrationsDialogStore();

  return (
    <PageHeaderActions
      route={ROUTES.IntegrationsApi}
      openDialog={() => openAddDialog(INTEGRATION_TYPE.Api)}
      addItem
    >
      <></>
    </PageHeaderActions>
  );
};

export default IntegrationsApiHeaderActions;
